import { render } from "./UdpdemoView.vue?vue&type=template&id=3ae58f78"
import script from "./UdpdemoView.vue?vue&type=script&lang=js"
export * from "./UdpdemoView.vue?vue&type=script&lang=js"

import "./UdpdemoView.vue?vue&type=style&index=0&id=3ae58f78&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__